import { useStyletron } from "baseui";
import {  TimeRange, startEndDateFromTimeRange } from "../../../../utils/timeUtils";
import { OperatorPanelWrapperFullSize } from "../../../components/Layout";
import { PortfolioEnergyChart } from "../PortfolioEnergyChart";
import { DisplayMode } from "../../../../hooks/useGetBuildingsEnergy";
import { FormattedMessage } from "react-intl";
import { ButtonGroup } from "baseui/button-group";
import { ParagraphMedium } from "baseui/typography";
import { Button } from "baseui/button";
import { useState } from "react";
import TotalOrSqmSelector from "../components/TotalOrSqmSelector";

export const OperatorPanel = (props: any) => {
    const [css, theme] = useStyletron();
    const { start, end } = startEndDateFromTimeRange(props.timeRange);
    const [sqm, setSqm] = useState(props.byM2)
    
    const convertToTons = !props.byM2;
    const displayUnitString = convertToTons ? "t" : 'kg';
    const valueFactor = convertToTons ? 0.001 : 1;
    return (
        <OperatorPanelWrapperFullSize
            {...props}
            statusContent={<>
                <div className={css({display: 'flex', flexDirection: 'row', alignItems: 'baseline', justifyContent: 'space-between', width: '100%'})} >
                    <ParagraphMedium margin={0}><Name {...props} start={start} end={end}></Name></ParagraphMedium>

                    <div className={css({ alignSelf: 'flex-end' })}>
                        <TotalOrSqmSelector byM2={props.byM2} onByM2Changed={(v) => setSqm(v)}/>
                    </div>
                </div>
            </>} >

            <PortfolioEnergyChart valueFactor={valueFactor} dimension={displayUnitString} colors={[theme.colors.positive200]} color={theme.colors.primary}  byM2={sqm} start={start} end={end} take={1000} displayMode={DisplayMode.CO2} ></PortfolioEnergyChart>
  
        </OperatorPanelWrapperFullSize>
    )
}

const Name = (props: any) => {

    const convertToTons = !props.byM2;
    const displayUnitString = convertToTons ? "Tons" : 'kg';

    return (
        <>
            <> <FormattedMessage id={TimeRange[props.timeRange]} defaultMessage={TimeRange[props.timeRange]} /> | {displayUnitString} CO2
            </>
            {props.byM2 && '/m²'}
        </>
    )
}